import i18n from "../../../../constants/i18n";
import { USER_PROMO_CODE_USAGE_HEADRS } from "../../../../constants/table-custom-headers/User";
import getPromoCodeUsageStore from "../../../../stores/user-store/promocode-code-usage-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const UserPromoCodeUsageData = withLiteObserverAndTheme(() => {
  const getPromoCodeUsageData =
    getPromoCodeUsageStore().promoCodeDataUsage.get();

  return (
    <Et3Table
      columns={USER_PROMO_CODE_USAGE_HEADRS}
      rows={getPromoCodeUsageData}
      title={i18n.get("USER_PROMO_CODE_USAGE_TABLE")}
      shouldBeFlagged={false}
      titleKey={"USER_PROMO_CODE_USAGE_TABLE"}
    />
  );
});
export default UserPromoCodeUsageData;
